
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4y252", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getBuildNumberFromKey", () => $a0ce8cbd61484647$export$ee58fde8e52c8848);
$parcel$export(module.exports, "getBuildInfoFromKey", () => $a0ce8cbd61484647$export$38ac5ad36585402e);
$parcel$export(module.exports, "default", () => $a0ce8cbd61484647$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bKxX9 = parcelRequire("bKxX9");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5ua7k = parcelRequire("5ua7k");

var $52w5V = parcelRequire("52w5V");
// 5 min polling interval
const $a0ce8cbd61484647$var$DEFAULT_POLLING_INTERVAL = 300000;
const $a0ce8cbd61484647$var$DEBUG_MODE_POLLING_INTERVAL = 10000;
const $a0ce8cbd61484647$var$getDebugModeFromLocalStorage = ()=>{
    try {
        const isDebugModeSetInLocalStorage = localStorage.getItem('remote-actions-debug-mode');
        return isDebugModeSetInLocalStorage === 'true';
    } catch (e) {
        return false;
    }
};
const $a0ce8cbd61484647$var$getDebugModeProps = (isRemoteActionsDebugMode)=>{
    if (isRemoteActionsDebugMode) return {
        product: 'jira.preview',
        pollingInterval: $a0ce8cbd61484647$var$DEBUG_MODE_POLLING_INTERVAL
    };
    return {
        product: 'jira',
        pollingInterval: $a0ce8cbd61484647$var$DEFAULT_POLLING_INTERVAL
    };
};
const $a0ce8cbd61484647$export$ee58fde8e52c8848 = (buildKey)=>{
    if (buildKey === 'JF-TEST') return Number.MAX_VALUE; // we never want range conditions to override JF-TEST builds.
    if (buildKey.startsWith('JF-BB') || buildKey.startsWith('MRJF-BB')) return Number.MAX_VALUE; // we never want range conditions to override branch builds.
    if (buildKey.startsWith('MRJF-PROD-HOTFIX')) return Number.MAX_VALUE; // we don't support hotfix builds yet for range conditions.
    const buildNumber = buildKey.match(/^(?:MR)?JF-PROD-(\d+)(-\w+)?$/);
    if (buildNumber) return parseInt(buildNumber[1], 10);
    throw new Error('Invalid build key');
};
const $a0ce8cbd61484647$var$matchBuildKey = (buildKey, buildKeyPattern)=>{
    const buildNumber = buildKey.match(buildKeyPattern);
    if (buildNumber) return parseInt(buildNumber[1], 10);
    throw new Error('Invalid build key');
};
const $a0ce8cbd61484647$export$38ac5ad36585402e = (buildKey)=>{
    if (buildKey === 'JF-TEST') return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'local'
    };
    if (buildKey.startsWith('MRJF-BB')) return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'branch'
    };
    if (buildKey.startsWith('MRJF-PROD-ALT')) return {
        buildNumber: $a0ce8cbd61484647$var$matchBuildKey(buildKey, /^MRJF-PROD-ALT-(\d+)(-\w+)?$/),
        buildType: 'alt'
    };
    if (buildKey.startsWith('MRJF-PROD-HOTFIX')) return {
        buildNumber: $a0ce8cbd61484647$var$matchBuildKey(buildKey, /^MRJF-PROD-HOTFIX-(\d+)(-\w+)?$/),
        buildType: 'hotfix'
    };
    return {
        buildNumber: $a0ce8cbd61484647$var$matchBuildKey(buildKey, /^MRJF-PROD-(\d+)(-\w+)?$/),
        buildType: 'prod'
    };
};
const $a0ce8cbd61484647$var$fireLifecycleAnalytics = (analyticsEvent, eventAction, attributes)=>{
    if ((0, $bKxX9.ff)('remote-actions-lifecycle-analytics_9n9tr')) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'remoteActions',
        frontendVersion: window.BUILD_KEY,
        ...attributes
    });
};
const $a0ce8cbd61484647$var$RemoteActions = ()=>{
    const [debugModeProps, setDebugModeProps] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const props = $a0ce8cbd61484647$var$getDebugModeProps($a0ce8cbd61484647$var$getDebugModeFromLocalStorage());
        setDebugModeProps(props);
    }, []);
    const onLifecycleEvent = (0, $eUqFw.useCallback)(({ action: action, attributes: attributes })=>{
        $a0ce8cbd61484647$var$fireLifecycleAnalytics(createAnalyticsEvent({}), action, attributes);
    }, [
        createAnalyticsEvent
    ]);
    if (!debugModeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52w5V.default), {
        endpoint: "/gateway/api/update-remote-action",
        product: debugModeProps.product,
        productData: {
            getBuildKey: ()=>window.BUILD_KEY,
            getBuildNumberFromKey: $a0ce8cbd61484647$export$ee58fde8e52c8848,
            getBuildInfoFromKey: $a0ce8cbd61484647$export$38ac5ad36585402e,
            getFeatureGateValue: (0, $eI5EY.fg),
            getFeatureFlagValue: (0, $bKxX9.ff)
        },
        pollingInterval: debugModeProps.pollingInterval,
        onLifecycleEvent: onLifecycleEvent
    });
};
const $a0ce8cbd61484647$var$IndexLegacy = ()=>{
    const [isRemoteActionsDebugMode] = (0, $5ua7k.useQueryParam)('isRemoteActionsDebugMode');
    const [debugModeProps, setDebugModeProps] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        const props = $a0ce8cbd61484647$var$getDebugModeProps(Boolean(isRemoteActionsDebugMode));
        setDebugModeProps(props);
    }, [
        isRemoteActionsDebugMode
    ]);
    if (!debugModeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52w5V.default), {
        endpoint: "/gateway/api/update-remote-action",
        product: debugModeProps.product,
        productData: {
            getBuildKey: ()=>window.BUILD_KEY,
            getBuildNumberFromKey: $a0ce8cbd61484647$export$ee58fde8e52c8848,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/ff/static-feature-flags
            getFeatureFlagValue: (key)=>(0, $bKxX9.getFeatureFlagValue)(key, undefined)
        },
        pollingInterval: debugModeProps.pollingInterval
    });
};
var $a0ce8cbd61484647$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $bKxX9.ff)('platform.remote-actions-improved-features_7ft0n_rlw3z'), $a0ce8cbd61484647$var$RemoteActions, $a0ce8cbd61484647$var$IndexLegacy);

});
parcelRegister("52w5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $785a103e2b84ce5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $6tFUq = parcelRequire("6tFUq");

var $dXpwH = parcelRequire("dXpwH");

var $gdW04 = parcelRequire("gdW04");
const $785a103e2b84ce5f$var$RemoteActionsManagerInternal = (props)=>{
    const { onLifecycleEvent: onLifecycleEvent } = props;
    const result = (0, $dXpwH.useRemoteActionsOnInterval)(props);
    (0, $eUqFw.useEffect)(()=>{
        if (onLifecycleEvent) {
            if (result?.deactivated) onLifecycleEvent({
                action: 'pollingStop'
            });
            else onLifecycleEvent({
                action: 'pollingStart'
            });
        }
    }, [
        result?.deactivated,
        onLifecycleEvent
    ]);
    return null;
};
function $785a103e2b84ce5f$var$RemoteActionsManagerInternalLegacy(props) {
    (0, $dXpwH.useRemoteActionsOnIntervalLegacy)(props);
    return null;
}
const $785a103e2b84ce5f$var$RemoteActionsManagerV2 = (props)=>{
    const { product: product, onLifecycleEvent: onLifecycleEvent } = props;
    const isLocalStorageSupportedRef = (0, $eUqFw.useRef)((0, $6tFUq.isLocalStorageSupported)());
    (0, $eUqFw.useEffect)(()=>{
        if (!isLocalStorageSupportedRef.current) {
            if (onLifecycleEvent) onLifecycleEvent({
                action: 'disabled',
                attributes: {
                    reason: 'localStorage not supported'
                }
            });
        }
    });
    if (!isLocalStorageSupportedRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gdW04.RemoteActionsContainer), {
        product: product,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($785a103e2b84ce5f$var$RemoteActionsManagerInternal, props));
};
const $785a103e2b84ce5f$var$RemoteActionsManager = (props)=>{
    const { product: product } = props;
    if ((0, $XHGTv.getBooleanFF)('platform.remote-actions-improved-features_7ft0n_rlw3z')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($785a103e2b84ce5f$var$RemoteActionsManagerV2, props);
    if (!(0, $6tFUq.isLocalStorageSupported)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gdW04.RemoteActionsContainer), {
        product: product,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($785a103e2b84ce5f$var$RemoteActionsManagerInternalLegacy, props));
};
var $785a103e2b84ce5f$export$2e2bcd8739ae039 = $785a103e2b84ce5f$var$RemoteActionsManager;

});
parcelRegister("6tFUq", function(module, exports) {

$parcel$export(module.exports, "isLocalStorageSupported", () => $b20dddb19944999c$export$bd6fa5db394a4992);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $b20dddb19944999c$export$bd6fa5db394a4992 = ()=>{
    try {
        // use an random key to test
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};

});

parcelRegister("dXpwH", function(module, exports) {

$parcel$export(module.exports, "useRemoteActionsOnIntervalLegacy", () => $2c55e0d31b44fa36$export$46e8ec2b7b8ee714);
$parcel$export(module.exports, "useRemoteActionsOnInterval", () => $2c55e0d31b44fa36$export$ee582f7d4b1ff42f);

var $eUqFw = parcelRequire("eUqFw");

var $lu9mt = parcelRequire("lu9mt");


var $gdW04 = parcelRequire("gdW04");

var $90Nvu = parcelRequire("90Nvu");

var $ilCxL = parcelRequire("ilCxL");
const $2c55e0d31b44fa36$export$46e8ec2b7b8ee714 = ({ endpoint: endpoint, product: product, productData: productData, pollingInterval: pollingInterval, idleTime: idleTime })=>{
    const { setCallRemoteActionsService: setCallRemoteActionsService, callRemoteActionsService: callRemoteActionsService, deactivated: deactivated, remoteActionsData: remoteActionsData } = (0, $ilCxL.useRemoteActionsServiceLegacy)(endpoint, product);
    const [{ isLoaded: isLoaded }, { processRemoteActions: processRemoteActions }] = (0, $gdW04.useRemoteActions)((state)=>({
            isLoaded: state.isLoaded
        }));
    const { active: active, tabActive: tabActive } = (0, $90Nvu.useBrowserInteractionTime)(idleTime || (0, $9aa509e99b18f723$export$af2ff676951003fe));
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoaded || remoteActionsData === null) return;
        processRemoteActions(productData, remoteActionsData);
    }, [
        processRemoteActions,
        isLoaded,
        product,
        productData,
        remoteActionsData
    ]);
    (0, $lu9mt.default)(()=>{
        if (callRemoteActionsService) return;
        // If the user is not active, do nothing.
        if (!active || !tabActive) return;
        setCallRemoteActionsService(true);
    }, pollingInterval || (0, $9aa509e99b18f723$export$f2b2f5ef0b498d26));
    return {
        deactivated: deactivated
    };
};
const $2c55e0d31b44fa36$export$ee582f7d4b1ff42f = ({ endpoint: endpoint, product: product, productData: productData, pollingInterval: pollingInterval, idleTime: idleTime })=>{
    const currentTime = Date.now();
    const interval = pollingInterval || (0, $9aa509e99b18f723$export$f2b2f5ef0b498d26);
    const { active: active, tabActive: tabActive } = (0, $90Nvu.useBrowserInteractionTime)(idleTime || (0, $9aa509e99b18f723$export$af2ff676951003fe));
    const previousActiveState = (0, $eUqFw.useRef)({
        active: active,
        tabActive: tabActive,
        timestamp: currentTime
    });
    const { setCallRemoteActionsService: setCallRemoteActionsService, callRemoteActionsService: callRemoteActionsService, deactivated: deactivated, setDeactivated: setDeactivated, remoteActionsData: remoteActionsData } = (0, $ilCxL.useRemoteActionsService)(endpoint, product);
    const [{ isLoaded: isLoaded }, { processRemoteActions: processRemoteActions }] = (0, $gdW04.useRemoteActions)((state)=>({
            isLoaded: state.isLoaded
        }));
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoaded || remoteActionsData === null) return;
        processRemoteActions(productData, remoteActionsData);
    }, [
        processRemoteActions,
        isLoaded,
        product,
        productData,
        remoteActionsData
    ]);
    (0, $lu9mt.default)(()=>{
        if (callRemoteActionsService) return;
        // If the user is not active, do nothing.
        if (!active || !tabActive) return;
        previousActiveState.current.timestamp = currentTime;
        setCallRemoteActionsService(true);
    }, interval);
    if (active && tabActive && (previousActiveState.current.active !== active || previousActiveState.current.tabActive !== tabActive) && currentTime - previousActiveState.current.timestamp > interval) {
        if (deactivated) setDeactivated(false);
        previousActiveState.current.timestamp = currentTime;
        setCallRemoteActionsService(true);
    }
    previousActiveState.current.active = active;
    previousActiveState.current.tabActive = tabActive;
    return {
        deactivated: deactivated
    };
};

});
parcelRegister("lu9mt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa43a9552c1c752d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $fa43a9552c1c752d$var$useInterval = function useInterval(callback, delay) {
    var savedCallbackRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(function() {
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(function() {
        var handler = function handler() {
            return savedCallbackRef.current.apply(savedCallbackRef, arguments);
        };
        if (delay !== null) {
            var intervalId = setInterval(handler, delay);
            return function() {
                return clearInterval(intervalId);
            };
        }
    }, [
        delay
    ]);
};
var $fa43a9552c1c752d$export$2e2bcd8739ae039 = $fa43a9552c1c752d$var$useInterval;

});

const $9aa509e99b18f723$export$f2b2f5ef0b498d26 = 5000;
const $9aa509e99b18f723$export$f2c0b74311ada874 = 3;
const $9aa509e99b18f723$export$af2ff676951003fe = 60000;
const $9aa509e99b18f723$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';

parcelRegister("gdW04", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $9cc563ab6643b6b8$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $9cc563ab6643b6b8$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $9cc563ab6643b6b8$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $9cc563ab6643b6b8$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $9cc563ab6643b6b8$export$3fd21eaf97df4718);

var $WBLbN = parcelRequire("WBLbN");

var $cqV4U = parcelRequire("cqV4U");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $WBLbN.defaults))) (0, $WBLbN.defaults).devtools = false;
const $9cc563ab6643b6b8$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $cqV4U.actions,
    name: 'remoteActionsStore'
});
const $9cc563ab6643b6b8$export$28c2e4c663a86266 = (0, $WBLbN.createContainer)($9cc563ab6643b6b8$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $cqV4U.actions).initStore());
        }
});
const $9cc563ab6643b6b8$export$333357b3de3e67a0 = (selector)=>(0, $WBLbN.createHook)($9cc563ab6643b6b8$var$Store, {
        selector: selector
    })();
const $9cc563ab6643b6b8$export$3cc006661ae2a759 = (0, $WBLbN.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.remoteActions
});
const $9cc563ab6643b6b8$export$3fb9275d3845bd5a = (0, $WBLbN.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.meta
});
const $9cc563ab6643b6b8$export$3fd21eaf97df4718 = (0, $WBLbN.createActionsHook)($9cc563ab6643b6b8$var$Store);

});
parcelRegister("cqV4U", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cd3fa27215f8b638$export$e324594224ef24da);

var $dnvcc = parcelRequire("dnvcc");

var $4t7Nl = parcelRequire("4t7Nl");

var $51DAc = parcelRequire("51DAc");

var $1xne4 = parcelRequire("1xne4");
const $cd3fa27215f8b638$export$e324594224ef24da = {
    processRemoteActions: $51DAc.processRemoteActions,
    saveActionPerformedAttempt: $1xne4.saveActionPerformedAttempt,
    initStore: $4t7Nl.initStore,
    clearActionId: $dnvcc.clearActionId
};

});
parcelRegister("dnvcc", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $7b090ca5222c318b$export$8d8b492eefa9efba);

var $fLzjp = parcelRequire("fLzjp");
const $7b090ca5222c318b$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("fLzjp", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $6e7cfc6bf9421aef$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $6e7cfc6bf9421aef$export$7228aaade919a8b6);
const $6e7cfc6bf9421aef$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $6e7cfc6bf9421aef$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $6e7cfc6bf9421aef$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4t7Nl", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $1e87662f3b55ae48$export$41f27b3823a442c6);

var $fLzjp = parcelRequire("fLzjp");
const $1e87662f3b55ae48$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $fLzjp.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("51DAc", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $134be2d45ea963a7$export$15e69d1dd38ccaa3);

var $ibqTf = parcelRequire("ibqTf");
const $134be2d45ea963a7$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $ibqTf.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $ibqTf.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: Date.now()
        });
    };

});
parcelRegister("ibqTf", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $cca0479d0b04fa6d$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $cca0479d0b04fa6d$export$c7cc93192d09a3d7);

var $XHGTv = parcelRequire("XHGTv");

var $fLduT = parcelRequire("fLduT");
const $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $cca0479d0b04fa6d$var$isBuildInAffectedRange = (getBuildKey, getBuildNumberFromKey, condition)=>{
    try {
        const currentBuildNumber = getBuildNumberFromKey(getBuildKey());
        const firstAffectedBuildNumber = getBuildNumberFromKey(condition.buildRange[0]);
        const lastAffectedBuildNumber = getBuildNumberFromKey(condition.buildRange[1]);
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $cca0479d0b04fa6d$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $fLduT.ConditionType).buildRange:
            return (0, $XHGTv.getBooleanFF)('platform.remote-actions-improved-features_7ft0n_rlw3z') && productData.getBuildInfoFromKey ? $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition) : $cca0479d0b04fa6d$var$isBuildInAffectedRange(productData.getBuildKey, productData.getBuildNumberFromKey, condition);
        case (0, $fLduT.ConditionType).featureFlag:
            return $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $fLduT.ConditionType).featureGate:
            return (0, $XHGTv.getBooleanFF)('platform.remote-actions-improved-features_7ft0n_rlw3z') && $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $cca0479d0b04fa6d$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("fLduT", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $fe90e03a6e8a0345$export$748d1c753cdf4bfd);
var $fe90e03a6e8a0345$export$748d1c753cdf4bfd;
(function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
})($fe90e03a6e8a0345$export$748d1c753cdf4bfd || ($fe90e03a6e8a0345$export$748d1c753cdf4bfd = {}));

});



parcelRegister("1xne4", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $4d7f44cfab8f48a4$export$e3144a2e886e0e77);

var $fLzjp = parcelRequire("fLzjp");
const $4d7f44cfab8f48a4$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("90Nvu", function(module, exports) {

$parcel$export(module.exports, "useBrowserInteractionTime", () => $8d270d6d1aef12ec$export$430908eb26d619ec);

var $eUqFw = parcelRequire("eUqFw");

var $cJt2B = parcelRequire("cJt2B");
const $8d270d6d1aef12ec$export$430908eb26d619ec = (threshold)=>{
    const [active, setActive] = (0, $eUqFw.useState)(true);
    const [tabActive, setTabActive] = (0, $eUqFw.useState)(true);
    const activeRef = (0, $eUqFw.useRef)(active);
    activeRef.current = active;
    (0, $eUqFw.useEffect)(()=>{
        let timer;
        timer = new (0, $cJt2B.default)({
            idleTimeoutMs: threshold,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>{
                    setTabActive(true);
                }
            ],
            browserTabInactiveCallbacks: [
                ()=>{
                    setTabActive(false);
                }
            ],
            idleCallbacks: [
                ()=>{
                    if (activeRef.current) setActive(false);
                }
            ],
            activeCallbacks: [
                ()=>{
                    if (!activeRef.current) setActive(true);
                }
            ]
        });
        timer.startTimer();
        return ()=>{
            timer && timer.destroy();
            timer = null;
        };
    }, [
        threshold
    ]);
    return {
        active: active,
        tabActive: tabActive
    };
};

});

parcelRegister("ilCxL", function(module, exports) {

$parcel$export(module.exports, "useRemoteActionsServiceLegacy", () => $cac3ca687c70b656$export$5dd3d742b2296454);
$parcel$export(module.exports, "useRemoteActionsService", () => $cac3ca687c70b656$export$28a02d6764b6d66c);

var $eUqFw = parcelRequire("eUqFw");


var $2LMWh = parcelRequire("2LMWh");

var $5ZxhY = parcelRequire("5ZxhY");
const $cac3ca687c70b656$export$5dd3d742b2296454 = (endpoint, product)=>{
    const [callRemoteActionsService, setCallRemoteActionsService] = (0, $eUqFw.useState)(false);
    const [deactivated, setDeactivated] = (0, $eUqFw.useState)(false);
    const [remoteActionsData, setRemoteActionsData] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (callRemoteActionsService && !deactivated) {
            const callAsync = async ()=>{
                try {
                    const response = await (0, $2LMWh.getRemoteActionsLegacy)(endpoint, product);
                    setCallRemoteActionsService(false);
                    if (response) setRemoteActionsData(response);
                } catch (error) {
                    setDeactivated(true);
                }
            };
            callAsync();
        }
    }, [
        callRemoteActionsService,
        endpoint,
        deactivated,
        product
    ]);
    return {
        remoteActionsData: remoteActionsData,
        setCallRemoteActionsService: setCallRemoteActionsService,
        callRemoteActionsService: callRemoteActionsService,
        deactivated: deactivated
    };
};
const $cac3ca687c70b656$export$28a02d6764b6d66c = (endpoint, product)=>{
    const [callRemoteActionsService, setCallRemoteActionsService] = (0, $eUqFw.useState)(false);
    const [deactivated, setDeactivated] = (0, $eUqFw.useState)(false);
    const [remoteActionsData, setRemoteActionsData] = (0, $eUqFw.useState)(null);
    const onBroadcastUpdate = (0, $eUqFw.useCallback)((message)=>{
        if (message.data.messageType === 'remote-action-polled') setRemoteActionsData(message.data.response);
    }, [
        setRemoteActionsData
    ]);
    const { postMessage: postMessage } = (0, $5ZxhY.useBroadcastChannel)(`${(0, $9aa509e99b18f723$export$388bd7a7ebb11e7)}-${product}`, onBroadcastUpdate);
    (0, $eUqFw.useEffect)(()=>{
        if (callRemoteActionsService && !deactivated) {
            const callAsync = async ()=>{
                try {
                    const response = await (0, $2LMWh.getRemoteActions)(endpoint, product);
                    setCallRemoteActionsService(false);
                    if (response) {
                        setRemoteActionsData(response);
                        postMessage({
                            response: response,
                            messageType: 'remote-action-polled'
                        });
                    }
                } catch (error) {
                    setDeactivated(true);
                }
            };
            callAsync();
        }
    }, [
        callRemoteActionsService,
        endpoint,
        deactivated,
        product,
        postMessage
    ]);
    return {
        remoteActionsData: remoteActionsData,
        setCallRemoteActionsService: setCallRemoteActionsService,
        setDeactivated: setDeactivated,
        callRemoteActionsService: callRemoteActionsService,
        deactivated: deactivated
    };
};

});
parcelRegister("2LMWh", function(module, exports) {

$parcel$export(module.exports, "getRemoteActionsLegacy", () => $59f4289e6be8bd97$export$e272cea23df7c014);
$parcel$export(module.exports, "getRemoteActions", () => $59f4289e6be8bd97$export$6e23e289b6bb0154);
const $59f4289e6be8bd97$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $59f4289e6be8bd97$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $59f4289e6be8bd97$var$fetchRetryLegacy(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $59f4289e6be8bd97$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $59f4289e6be8bd97$var$timeout(backoff);
        return await $59f4289e6be8bd97$var$fetchRetryLegacy(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
async function $59f4289e6be8bd97$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 1 && $59f4289e6be8bd97$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $59f4289e6be8bd97$var$timeout(backoff);
        return await $59f4289e6be8bd97$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else throw new Error(`Failed to fetch remote actions with status ${response.status}`);
}
const $59f4289e6be8bd97$var$getRemoteActionsUrlForProduct = (endpoint, product)=>`${endpoint}/${product}.json`;
const $59f4289e6be8bd97$export$e272cea23df7c014 = async (endpoint, product)=>{
    try {
        const remoteActionsUrl = $59f4289e6be8bd97$var$getRemoteActionsUrlForProduct(endpoint, product);
        const response = await $59f4289e6be8bd97$var$fetchRetryLegacy(remoteActionsUrl, {
            cache: 'no-store',
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401) {
            console.warn('failed auth');
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            console.warn('bad request');
            return Promise.reject(errorResponse);
        }
        if ($59f4289e6be8bd97$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Remote Actions: Retried 5x, stopped to call api');
    }
};
const $59f4289e6be8bd97$export$6e23e289b6bb0154 = async (endpoint, product)=>{
    const remoteActionsUrl = $59f4289e6be8bd97$var$getRemoteActionsUrlForProduct(endpoint, product);
    const response = await $59f4289e6be8bd97$var$fetchRetry(remoteActionsUrl, {
        cache: 'no-store',
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (response && response.ok) {
        const remoteActionsResponse = await response.json();
        if (remoteActionsResponse && typeof remoteActionsResponse.lastUpdatedAt === 'number' && remoteActionsResponse.remoteActions instanceof Array) return remoteActionsResponse;
    }
};

});

parcelRegister("5ZxhY", function(module, exports) {

$parcel$export(module.exports, "useBroadcastChannel", () => $819bac45f71e64c2$export$e38c76da774a8077);

var $eUqFw = parcelRequire("eUqFw");
const $819bac45f71e64c2$var$createBroadcastChannel = (channelName)=>{
    try {
        // eslint-disable-next-line compat/compat
        return new BroadcastChannel(channelName);
    } catch  {
        return null;
    }
};
const $819bac45f71e64c2$export$e38c76da774a8077 = (channelName, callback)=>{
    const channel = (0, $eUqFw.useRef)(null);
    const savedCallback = (0, $eUqFw.useRef)(callback);
    (0, $eUqFw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (channel.current) {
            channel.current.removeEventListener('message', savedCallback.current);
            channel.current.close();
            channel.current = null;
        }
        channel.current = $819bac45f71e64c2$var$createBroadcastChannel(channelName);
        if (channel.current) channel.current.addEventListener('message', (event)=>{
            savedCallback.current(event);
        });
        return ()=>{
            if (channel.current) {
                channel.current.removeEventListener('message', savedCallback.current);
                channel.current.close();
                channel.current = null;
            }
        };
    }, [
        channelName
    ]);
    if (channel.current) return {
        postMessage: (message)=>{
            channel.current?.postMessage(message);
        }
    };
    return {
        postMessage: ()=>{}
    };
};

});






//# sourceMappingURL=async-remote-actions.cdbc6d5d.js.map
